// extracted by mini-css-extract-plugin
export var alternate = "_s-j";
export var black = "_s-6";
export var blue = "_s-f";
export var blueLight = "_s-e";
export var brand = "_s-8";
export var darkMode = "_s-b";
export var error = "_s-a";
export var gray = "_s-5";
export var grayBlue = "_s-d";
export var iconWrapper = "_s-3";
export var inactive = "_s-7";
export var indigo = "_s-g";
export var orange = "_s-i";
export var pink = "_s-h";
export var primary = "_s-0";
export var purple = "_s-9";
export var success = "_s-4";
export var warning = "_s-c";
export var white = "_s-1";
export var whiteSuccess = "_s-2";